import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import notifications from './routes/notifications'
import stores from './routes/stores'
import campaign from './routes/campaign'
import flows from './routes/flows'
import painel from './routes/painel'
import register from './routes/register'
import cs from './routes/customer-success'
import attending from './routes/attending'
import sales from './routes/sales'
import bot from './routes/bot'
import kanban from './routes/kanban'
import chat from './routes/chat'
import onboarding from './routes/onboarding'
import novidades from './routes/novidades'
import users from './routes/users'
import templates from './routes/templates'
import audience from './routes/audiencia'
import account from './routes/account'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: () =>
        // Se o usuário estiver logado, vai para dashboard-main
        // Se não estiver logado, vai para login
        (isUserLoggedIn() ? { name: 'dashboard-main' } : { name: 'auth-login' }),

    },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...notifications,
    ...stores,
    ...campaign,
    ...flows,
    ...painel,
    ...register,
    ...cs,
    ...attending,
    ...sales,
    ...bot,
    ...kanban,
    ...chat,
    ...onboarding,
    ...novidades,
    ...users,
    ...templates,
    ...audience,
    ...account,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
